import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const useLogout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return handleLogout;
};

export default useLogout;